import Dropzone from "../Dropzone";
import { router } from "@inertiajs/react";
import { vacancies } from "@/api";
import { useEffect, useState } from "react";
import VacancyFile from "./VacancyFile";

const ACCPET = {
  "text/plain": [".txt"],
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
};

export default function Form({ vacancy, vacancyFile }) {
  const onUploaded = (blobs) => {
    const blob = blobs[0];
    router.post(vacancies.create.path(), { blob_signed_id: blob.signed_id });
  };

  const [description, setDescription] = useState(vacancy?.description || "");

  useEffect(() => {
    if (!description || description.trim() === "") return;
    router.post(vacancies.create.path(), { title: description });
  }, [description]);

  return (
    <>
      <Dropzone
        accept={ACCPET}
        onUploaded={onUploaded}
        label="上传职位描述文件"
        helpText="支持 TXT, PNG, JPG, PDF, DOCX 格式"
      />
      {vacancy && vacancyFile && (
        <VacancyFile vacancy={vacancy} vacancyFile={vacancyFile} />
      )}
      <div className="mt-6">
        <label
          htmlFor="description"
          className="block text-sm font-medium text-gray-700 mb-2"
        >
          职位描述文本
        </label>
        <textarea
          id="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={6}
          className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          placeholder="在此输入或粘贴职位描述..."
        />
      </div>
    </>
  );
}
